import { useTranslation } from 'react-i18next';
import { useOnline } from '../../hooks/useOnline';

/** Part F — Connection lost → red banner at top + mutations should be disabled. */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnline();
  if (online) return null;
  return (
    <div className="bg-destructive text-destructive-foreground text-sm text-center py-1">
      {t('ui.offline')}
    </div>
  );
}
